import script from "./Training.vue?vue&type=script&setup=true&lang=js"
export * from "./Training.vue?vue&type=script&setup=true&lang=js"

import "./Training.vue?vue&type=style&index=0&id=5bca6678&lang=scss&scoped=true"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-5bca6678"]])

export default __exports__